<template>
  <el-tooltip v-if="config.tooltip" :content="config.tooltip" placement="top">
    <span class="status-badge" :class="config.cssClass">{{ statusName }}<span v-if="config.icon" class="status-badge__icon">{{ config.icon }}</span></span>
  </el-tooltip>
  <span v-else class="status-badge" :class="config.cssClass">{{ statusName }}</span>
</template>

<script>
export default {
  name: 'StatusBadge',
  props: {
    statusName: {
      type: String,
      default: ''
    },
    statusColor: {
      type: String,
      default: ''
    }
  },
  computed: {
    config () {
      if (this.statusName === 'Утвержден' && this.statusColor === 'warning') {
        return { cssClass: 'status-badge--pending', icon: '⏳', tooltip: 'Ожидает подписания на Портале' }
      }
      if (this.statusName === 'Утвержден') {
        return { cssClass: 'status-badge--approved' }
      }
      if (this.statusName === 'Подтвержден') {
        return { cssClass: 'status-badge--confirmed' }
      }
      if (this.statusName === 'Отредактирован') {
        return { cssClass: 'status-badge--edited' }
      }
      if (this.statusName === 'Отправлен') {
        return { cssClass: 'status-badge--sent' }
      }
      if (this.statusName === 'Отменен' || this.statusName === 'Отклонен') {
        return { cssClass: 'status-badge--canceled' }
      }
      return { cssClass: 'status-badge--neutral' }
    }
  }
}
</script>

<style scoped>
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  border: 1px solid transparent;
}
.status-badge__icon {
  font-size: 11px;
}
.status-badge--approved {
  color: #27AE60;
  background: #E8F7EF;
}
.status-badge--pending {
  color: #E3A32A;
  background: #FDF3DE;
  cursor: default;
}
.status-badge--confirmed {
  color: #fff;
  background: #27AE60;
}
.status-badge--edited {
  color: #3E8EDE;
  background: #EAF3FC;
}
.status-badge--sent {
  color: #3E8EDE;
  background: #fff;
  border-color: #3E8EDE;
}
.status-badge--canceled {
  color: #E85252;
  background: #fff;
  border-color: #E85252;
}
.status-badge--neutral {
  color: #7A8794;
  background: #fff;
  border-color: #DFE6ED;
}
</style>
